import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { StateContext } from '../../../../../StateProvider';
import { BackButton } from '../../../../../Utilities/components/Buttons';

import './PaymentMethods.css';

import visaIcon from '../../../../../../assets/Dashboard/Profile/components/Wallet/visaIcon.png';
import masterIcon from '../../../../../../assets/Dashboard/Profile/components/Wallet/masterIcon.png';
import amexIcon from '../../../../../../assets/Dashboard/Profile/components/Wallet/amexIcon.png';
import discoverIcon from '../../../../../../assets/Dashboard/Profile/components/Wallet/discoverIcon.png';
import defaultIcon from '../../../../../../assets/Dashboard/Profile/components/Wallet/defaultIcon.png';

function getCardIcon(cardType) {
  if (!cardType) return visaIcon;

  var key = String(cardType).toLowerCase();

  if (key === "visa") return visaIcon;
  if (key === "mastercard" || key === "master card") return masterIcon;
  if (key === "amex" || key === "american express") return amexIcon;
  if (key === "discover") return discoverIcon;

  return visaIcon;
}

export default function PaymentMethods() {
  const navigate = useNavigate();
  const ctx = useContext(StateContext);

  const user = ctx ? ctx.user : null;
  const methods = ctx && ctx.paymentMethods ? ctx.paymentMethods : [];

  var hasMethods = false;
  if (methods && typeof methods.length === "number" && methods.length > 0) {
    hasMethods = true;
  }

  var defaultPmId = "";
  if (user && user.defaultPaymentMethodId) {
    defaultPmId = String(user.defaultPaymentMethodId);
  }

  return (
    <div className="container">
      <BackButton />

      <div className="payment-methods-section">

        {hasMethods ? (
          methods.map(function (method, index) {
            var stripePmId = method && method.stripePaymentMethodId
              ? String(method.stripePaymentMethodId)
              : "";

            var isDefault = false;
            if (stripePmId && defaultPmId && stripePmId === defaultPmId) {
              isDefault = true;
            }

            var cardType = method && method.cardType ? method.cardType : "";
            var icon = getCardIcon(cardType);

            var lastFour = "----";
            if (method && method.cardNumber) {
              var numStr = String(method.cardNumber);
              lastFour = numStr.substring(numStr.length - 4);
            }

            var expiryMonth = method && method.expiryMonth ? method.expiryMonth : "";
            var expiryYear = method && method.expiryYear ? method.expiryYear : "";

            var formattedYear = "--";
            if (expiryYear) {
              var yrStr = String(expiryYear);
              if (yrStr.length <= 2) {
                formattedYear = yrStr;
              } else {
                formattedYear = yrStr.substring(yrStr.length - 2);
              }
            }

            return (
              <div key={index}>
                <div
                  className="payment-method"
                  onClick={function () {
                    var pmId = method && method.stripePaymentMethodId
                      ? String(method.stripePaymentMethodId)
                      : "";

                    // Only navigate if Stripe ID is valid
                    if (pmId && pmId.substring(0, 3) === "pm_") {
                      navigate("/profile/wallet/payment-methods/edit-payment/" + pmId);
                    }
                  }}
                >
                  <img
                    className="payment-method-image"
                    src={icon}
                    alt={(cardType || "Card") + " icon"}
                  />

                  <div className="payment-method-details">

                    <div className="cardName-cardDefault">
                      <h3 className="payment-method-name">
                        {cardType
                          ? cardType.charAt(0).toUpperCase() +
                            cardType.slice(1)
                          : "Card"}
                      </h3>

                      {isDefault ? (
                        <img
                          src={defaultIcon}
                          alt="default card"
                          className="default-badge-image"
                        />
                      ) : null}
                    </div>

                    <p className="payment-method-type">
                      **** **** **** {lastFour}
                    </p>

                    <div className="payment-method-badges-container">
                      <span className="payment-method-badge">
                        Expires {expiryMonth}/{formattedYear}
                      </span>
                    </div>

                  </div>
                </div>

                <hr className="payment-method-breakline" />
              </div>
            );
          })
        ) : (
          <div className="payment-method-message">
            Please add a payment method.
          </div>
        )}

        <div className="add-payment-method-button-container">
          <button
            className="add-payment-method-button"
            onClick={function () {
              navigate('/profile/wallet/payment-methods/add-payment');
            }}
          >
            + Add Payment
          </button>
        </div>
      </div>
    </div>
  );
}
